export const isEmpty = (v) =>
    v === undefined || v === null || v === "";

export const toLocalDate = (utcString) => new Date(utcString);

export const toLocalDateString = (utcString) => new Date(utcString).toLocaleString();
